import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { INTERESTS, AREAS, CONTACT, BUDGET_RANGES } from "../lib/constants";

const API = `${process.env.REACT_APP_BACKEND_URL || 'https://vachhraj-api.onrender.com'}/api`;

export const EnquiryForm = ({ compact = false }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    interest: "Residential",
    area: "",
    budget: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please share your name and phone number.");
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        name: form.name.trim(),
        phone: form.phone.trim(),
        interest: form.interest,
      };
      if (form.email.trim()) payload.email = form.email.trim();
      if (form.area) payload.area = form.area;
      if (form.budget.trim()) payload.budget = form.budget.trim();
      if (form.message.trim()) payload.message = form.message.trim();

      await axios.post(`${API}/enquiries`, payload);
      toast.success("Enquiry received. We will reach out shortly.");

      const budgetLabel = BUDGET_RANGES.find(b => b.value === form.budget)?.label || "";
      
      const wa = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(
        `Hello Vachhraj Estate,
Name: ${form.name}
Phone: ${form.phone}
Interest: ${form.interest}${
          form.area ? `
Area: ${form.area}` : ""
        }${
          budgetLabel ? `
Budget: ${budgetLabel}` : ""
        }${
          form.message ? `
Message: ${form.message}` : ""
        }`
      )}`;
      window.open(wa, "_blank", "noopener,noreferrer");

      setForm({
        name: "",
        phone: "",
        email: "",
        interest: "Residential",
        area: "",
        budget: "",
        message: "",
      });
    } catch (err) {
      console.error("Error submitting form:", err);
      console.error("Error response:", err.response?.data);
      console.error("Error status:", err.response?.status);
      toast.error("Could not submit. Please try WhatsApp or call the office.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="w-full">
      <div className={`grid gap-6 ${compact ? "grid-cols-1" : "grid-cols-1 md:grid-cols-2"}`}>
        <div>
          <label className="ve-label" htmlFor="ve-name">Full Name*</label>
          <input
            id="ve-name"
            className="ve-input"
            placeholder="e.g. Rahul Shah"
            value={form.name}
            onChange={(e) => set("name", e.target.value)}
            required
          />
        </div>
        <div>
          <label className="ve-label" htmlFor="ve-phone">Phone*</label>
          <input
            id="ve-phone"
            className="ve-input"
            type="tel"
            placeholder="10-digit mobile"
            pattern="[6-9][0-9]{9}"
            title="Enter 10-digit mobile number starting with 6-9"
            value={form.phone}
            onChange={(e) => set("phone", e.target.value)}
            required
          />
        </div>
        <div>
          <label className="ve-label" htmlFor="ve-email">Email (optional)</label>
          <input
            id="ve-email"
            className="ve-input"
            type="email"
            placeholder="name@email.com"
            value={form.email}
            onChange={(e) => set("email", e.target.value)}
          />
        </div>
        <div>
          <label className="ve-label" htmlFor="ve-interest">I'm looking for*</label>
          <select
            id="ve-interest"
            className="ve-input"
            value={form.interest}
            onChange={(e) => set("interest", e.target.value)}
          >
            {INTERESTS.map((i) => (
              <option key={i} value={i} style={{ background: "var(--ink-700)" }}>
                {i}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="ve-label" htmlFor="ve-area">Preferred Area</label>
          <select
            id="ve-area"
            className="ve-input"
            value={form.area}
            onChange={(e) => set("area", e.target.value)}
          >
            <option value="" style={{ background: "var(--ink-700)" }}>Any area</option>
            {AREAS.map((a) => (
              <option key={a.name} value={a.name} style={{ background: "var(--ink-700)" }}>
                {a.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="ve-label" htmlFor="ve-budget">Budget Range</label>
          <select
            id="ve-budget"
            className="ve-input"
            value={form.budget}
            onChange={(e) => set("budget", e.target.value)}
          >
            {BUDGET_RANGES.map((b) => (
              <option key={b.value} value={b.value} style={{ background: "var(--ink-700)" }}>
                {b.label}
              </option>
            ))}
          </select>
        </div>
        <div className="md:col-span-2">
          <label className="ve-label" htmlFor="ve-message">Tell us more</label>
          <textarea
            id="ve-message"
            className="ve-input"
            rows={3}
            placeholder="Size, configuration, timeline, anything specific…"
            value={form.message}
            onChange={(e) => set("message", e.target.value)}
          />
        </div>
      </div>
      <div className="mt-8 flex flex-wrap items-center gap-4">
        <button type="submit" className="ve-btn-primary" disabled={submitting}>
          {submitting ? "Sending…" : "Submit Enquiry"}
        </button>
        <a
          href={CONTACT.whatsappLink}
          target="_blank"
          rel="noreferrer"
          className="ve-btn-whatsapp"
        >
          Or Chat on WhatsApp
        </a>
        <span
          className="text-xs tracking-[0.18em] uppercase"
          style={{ color: "var(--cream-500)" }}
        >
          We respond within working hours.
        </span>
      </div>
    </form>
  );
};

export default EnquiryForm;